import React from 'react';
import { Hero } from '../components/home/Hero';
import { TrustBar } from '../components/home/TrustBar';
import { PickYourSport } from '../components/home/PickYourSport';
import { WhyChoosePts } from '../components/home/WhyChoosePts';
import { OrderProcess } from '../components/home/OrderProcess';
import { TeamPackages } from '../components/home/TeamPackages';
import { TeamStoresSection } from '../components/home/TeamStoresSection';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { FinalCta } from '../components/home/FinalCta';
export function Home() {
  return <div className="w-full" data-id="element-565">
      <Hero data-id="element-566" />
      <TrustBar data-id="element-567" />
      <PickYourSport data-id="element-568" />
      <WhyChoosePts data-id="element-569" />
      <OrderProcess data-id="element-570" />
      <TeamPackages data-id="element-571" />
      <TeamStoresSection data-id="element-572" />
      <ReviewsSection data-id="element-573" />
      <FinalCta data-id="element-574" />
    </div>;
}